import React, { useEffect, useState } from 'react'
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../Services/axios';
import OfferCard from './offercard';
import { toast } from 'react-toastify';
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import { showToast } from '../../Components/toastConfig/ToastConfig';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import store_icon from "../../Assets/Images/icons/store_icon.png"
import { useSelector } from 'react-redux';
import { fetchVendorOfferList } from '../../Services/api';

const Offerslist = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const { vendor_Id, flowParent, vendorName } = location.state || {};
    const [data, setData] = useState('')
    const [offers, setOffers] = useState([])
    let { vendorId } = useParams();
    const [pageLoaded, setPageLoaded] = useState(false)
    useEffect(() => {
        getofferlist()
    }, [])

    const getofferlist = async() => {
        try {
            let reqData = {
                "vendor_id": vendorId
            }

            let res = await fetchVendorOfferList(reqData);
            if (res?.status == 200) {
                setOffers(res.data.vendor_offer_list)
                setData(res.data)
                setPageLoaded(true)
            }
        } catch (err) {
            if (err.response.status == 400 || err.response.status == 500) {
                showToast(err.response || "Something went wrong, please try again later");
            }
        }
    }


    return (
        <div className=''>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">

                    <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(`/vendor/${data.vendor_id}`)} />
                    <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                        Offers
                    </div>
                </div>

                <div className="d-flex align-items-center goStoreBar" onClick={() => navigate(`/vendor/${vendorId}`)}>
                    <img src={store_icon} height="20" width="20" />
                    <span className="fs-12 ff-poppins-medium ms-1">Go to store</span>
                </div>
            </div>
            <div className='scroller-style-y mb-3 pb-4'>
                <div className="p-3 ">
                    <p className="ff-poppins-bold fs-24 ms-2 secondary-text m-0"> {vendorName}</p>
                </div>
                {
                    pageLoaded ?

                        offers.length > 0 ?
                            offers.map((list, index) => {
                                return (
                                    <div onClick={() => {
                                        if ((list.usage_limit_status == "1" && list.usage_limit == 0) || (list.usage_limit_per_user == list.offer_used_count)) {
                                            toast.error('Offer unavailable', {
                                                position: toast.POSITION.BOTTOM_CENTER
                                            });
                                        } else if (list.offer_used_count >= list.usage_limit_per_user) {
                                            toast.error('Offer limit reached per user', {
                                                position: toast.POSITION.BOTTOM_CENTER
                                            });
                                        } else {
                                            navigate(`/OfferDetails/${vendorId}/${list.offer_id}`, { state: { offerid: list.offer_id, vendorId, categoryStatus: list.applied_to_status } })
                                        }
                                    }}>
                                        <OfferCard key={index} data={list} offer_from_Page={"Offer_list"} />
                                    </div>
                                )
                            })
                            :
                            <>
                                <div>
                                    <Lottie animationData={empotyLottie} />
                                </div>
                                <p className='text-dark text-center mt-5 ff-balooPaaji2-bold fs-20 '>No Offer Available</p>

                            </>
                        :
                        <div className='d-flex justify-content-center skeleton-bg'>
                            <div >
                                <Skeleton height={50} width={375} />
                                <Skeleton height={90} width={375} />
                                <Skeleton height={50} width={375} />
                                <Skeleton height={90} width={375} />
                                <Skeleton height={50} width={375} />
                                <Skeleton height={90} width={375} />
                                <Skeleton height={50} width={375} />
                                <Skeleton height={90} width={375} />
                            </div>
                        </div>
                }
            </div>
        </div>
    )
}

export default Offerslist